import { useCallback } from 'react';

const useCellphoneValidation = () => {
    const validatePhone = useCallback((phone: string): boolean => {
        if (!phone) return false;

        const cleanedPhone = phone.replace(/[^\d]/g, ''); // Remove todos os caracteres não numéricos
        const lengthValid = [10, 11].includes(cleanedPhone.length); // Comprimento de 10 (fixo) ou 11 (móvel)
        const formattedLengthValid = /^[1-9][1-9]/.test(cleanedPhone); // Verifica se os dois primeiros dígitos não são 00, 01, ou 10
        const noZeroAfterDDD = !/^.{2}0/.test(cleanedPhone);

        return (
        lengthValid &&
        formattedLengthValid &&
        noZeroAfterDDD
        );
    }, []);

    return validatePhone;
};

export default useCellphoneValidation;